//Progress bar limits
let Cpage = 1;
let allProductsData = 0;

// Global variables
let progress = 0;
let mysteryGiftLimit;
let freeShippingLimit;
let currentRate;
let targetCurrency;
let isGiftFree = false;
let isGiftInCart = true;
var drawerSliderInit = 0;

// Global convertPrice function
function convertPrice(usdPrice, exchangeRate) {
    const ratio = 1 / exchangeRate;
    const result = (Number(usdPrice) * Number(ratio)).toFixed(2);
    return result;
}

// Global formatMoney function
function formatMoney(number, currency) {
    const resMoney = Number(number).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'USD',
    });
    return resMoney;
}

// Global setProgress function
function setProgress(bar, prog, drawer, shippingVal) {
    if (Number(prog) >= 100) {
        bar.style.width = "100%";
        drawer.classList.add('deal-3');
        drawer.classList.remove('deal-2', 'deal-1');
    } else {
        bar.style.width = `${prog}%`;
        Number(prog) >= shippingVal ?
            (
                drawer.classList.add('deal-2'),
                drawer.classList.remove('deal-1', 'deal-3')
            )
            :
            (
                drawer.classList.add('deal-1'),
                drawer.classList.remove('deal-2', 'deal-3')
            )
    }
}




// Handle checkout button
var checkoutBusy = false;

function checkOutFire(checkoutButton) {
    checkoutButton.addEventListener('click', function(ev) {
        if (checkoutBusy) return;
        checkoutBusy = true;
        ev.preventDefault();

        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let exchangeRate = window.Shopify.currency.rate || 1; 
                let subtotalInUSD = convertPrice(cart.total_price / 100, exchangeRate); 

                if (subtotalInUSD < 162) {
                    checkoutBusy = false;
                    window.location.href = '/checkout';
                } else {

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: giftVarId,
                            quantity: 1,
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        checkoutBusy = false;
                        window.location.href = '/checkout';
                    })
                    .catch((error) => {
                        console.error(error);
                        checkoutBusy = false;
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                checkoutBusy = false;
            });
    });
}






     // Global updateCartDrawer function
     let isDrawerUpdating = false;
     function updateCartDrawer() {

          if (isDrawerUpdating) return;

          const drawer = document.querySelector('cart-drawer.drawer');

          if (!drawer.classList.contains('is-empty')){

               isDrawerUpdating = true;

               const totalElem = document.querySelector('.drawer__totals-subtotal-value');
               const totalPrice = totalElem.getAttribute('data-total');
               const barItem = document.querySelector('.drawer__progress-bar--progress') || 0;
               const giftItem = document.getElementById('drawer__gift-item') || 0;
               const barTotal = convertPrice(162, currentRate);
               const shippingPr = convertPrice(fresShippingUSDLimit, currentRate);
               const shippingVal = ((Number(shippingPr) / Number(barTotal)) * 100).toFixed();

               barItem && setProgress(barItem, progress, drawer, shippingVal);
               barItem && barItem.classList.add('anim');
               progress = ((Number(totalPrice) / Number(barTotal)) * 100);
               setTimeout(() => {
                    barItem && setProgress(barItem, progress, drawer, shippingVal);
                    if (allProductsData) setDrawerGiftItem(allProductsData);
               });

               if (Number(mysteryGiftLimit) < Number(totalPrice)) {
                    if (giftItem) {
                         giftItem.classList.add('selected');
                         const statusItem = giftItem.querySelector('.drawer__gift-status-item');
                         statusItem.innerText = statusItem.dataset.unlocked;
                    }
                    isGiftFree = true;
               } else {
                    const mysteryNeeds = formatMoney((mysteryGiftLimit - totalPrice).toFixed(), targetCurrency);
                    document.querySelector('.drawer__heading-subtitle--mystery-gift-price').innerText = mysteryNeeds;
                    if (giftItem){
                         giftItem.classList.remove('selected');
                         const statusItem = giftItem.querySelector('.drawer__gift-status-item');
                         statusItem.innerText = `${mysteryNeeds} ${statusItem.dataset.away}`;
                         giftItem.classList.remove('selected');
                    }
                    isGiftFree = false;
               }

               if (Number(freeShippingLimit) >= Number(totalPrice)){
                    const fsNeeds = formatMoney((freeShippingLimit - totalPrice), targetCurrency);
                    document.querySelector('.drawer__heading-subtitle--free-shipping-price').innerText = fsNeeds;
                    const statusItem = document.querySelector('.drawer__shipping-status-item');
                    statusItem.innerText = `${fsNeeds} ${statusItem.dataset.away}`;
               } else{
                    document.getElementById('drawer__shipping-img').src = 'https://cdn.shopify.com/s/files/1/0553/8673/4747/files/free-shipping.webp?v=1737660201';
                    const statusItem = document.querySelector('.drawer__shipping-status-item');
                    statusItem.innerText = statusItem.dataset.unlocked;
               }

               checkoutButton = document.getElementById('drawer__checkout-button');
               checkOutFire(checkoutButton);

               isDrawerUpdating = false;

          }

          allProductsData && renderSelectedProducts();

     }

// Global setDrawerGiftItem function
function setDrawerGiftItem(data) {
    const foundProduct = data.products.find(product => product.id === giftId);

    if (!foundProduct) {
        fetchProducts(Cpage + 1);
        return;
    }

    const giftItem = document.getElementById('drawer__gift-item');

    if (foundProduct && giftItem) {
        document.getElementById('drawer__gift-title').innerText = foundProduct.title;
        document.getElementById('drawer__gift-img').src = foundProduct.images[0].src;
        document.getElementById('drawer__gift-img').alt = foundProduct.title;

     //    const price = foundProduct.variants[0].compare_at_price;
     //    document.getElementById('drawer__gift-price-compare').innerText = formatMoney(price, targetCurrency);
    }
}

// All loaded funcs
document.addEventListener('DOMContentLoaded', function () {

    var cartHasItems = false;

    const checkoutButton = document.getElementById('drawer__checkout-button');
     checkOutFire(checkoutButton);
     
    // Get drawer
    var barItem = document.querySelector('.drawer__progress-bar--progress');
    var giftItem = document.getElementById('drawer__gift-item');

     // Get total elem and currency
     var totalElem = document.querySelector('.drawer__totals-subtotal-value'),
     totalPrice;
     targetCurrency = totalElem.getAttribute('data-currency');
     const targetCurrencySymbol = totalElem.getAttribute('data-currency-symbol') || 0;
     currentRate = Currency.rates[targetCurrency];
     mysteryGiftLimit = convertPrice(mysteryGiftUSDLimit, currentRate);
     freeShippingLimit = convertPrice(fresShippingUSDLimit, currentRate);

     function cartDetect() {
          var cartDrawer = document.querySelector('cart-drawer.drawer');
          if (cartDrawer) {
               var cartItems = cartDrawer.querySelector('.cart-items');
               if (cartItems) {
                    cartHasItems = true;
                    updateCartDrawer();
               }
          }
     }

     cartDetect();



     // function observeCartChanges() {

     //      const cartObserver = new PerformanceObserver((list) => {
     //           list.getEntries().forEach((entry) => {
     //                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
     //                const isCartChangeRequest = entry.name.includes('cart');

     //                setTimeout(() => {
     //                     if (isCartChangeRequest && isValidRequestType) {
     //                          cartDetect();
     //                     }
     //                });
     //           });
     //      });

     //      cartObserver.observe({ entryTypes: ["resource"] });

     // }
     
     // observeCartChanges();







     // Fetch Products
     function fetchProducts(Cpage) {
          fetch(`/products.json?limit=250&page=${Cpage}`)
               .then(response => response.json())
               .then(res => {
                    allProductsData = res;
                    setDrawerGiftItem(allProductsData)
                    renderSelectedProducts()
               });
     }

    fetchProducts(Cpage);



     


});


